module.exports = __webpack_public_path__ + "static/theia-gravidez-print3-3529e92ec53c61be548afb8f9515e764.png";